<template>
  <header class="header">
    <div class="warp">
      <div class="logo">
        <img
          src="@/views/images/logos.png"
          @click="toPath(navs[0])"
          alt=""
          class="logo"
        />
      </div>
      <!-- text30 -->
      <!-- <div class="searchCon">
        <input
          type="text"
          :placeholder="'请输入标的名称/编号'"
          v-model="queryInfo.query"
        />
        <div class="button" @click="routclickss(queryInfo.query)">搜索</div>
      </div> -->
      <div class="rightBar">
        <div class="rightIcon" v-show="!isLogin">
          <div class="login iconRow" @click="routePush('/login', 'login')">
            <!-- <i class="iconfont icon-weidenglu" /> -->
            <el-icon color="#c08c58" size="20">
              <UserFilled />
            </el-icon>
            <text>登录</text>
          </div>
          <div class="regist iconRow" @click="routePush('/login', 'zhuce')">
            <!-- <i class="iconfont icon-zhuce" /> -->
            <el-icon color="#c08c58" size="20">
              <Avatar />
            </el-icon>
            <text>注册</text>
          </div>
        </div>
        <div class="rightIcon" v-show="isLogin">
          <div class="message iconRow">
            <el-badge
              v-if="messageData.msgNum + messageData.toDoNum"
              :value="messageData.msgNum + messageData.toDoNum"
              class="item"
            >
              <!-- <i class="iconfont icon-xiaoxi" /> -->
              <el-icon color="#c08c58" size="20" style="margin-top: 10px">
                <Bell />
              </el-icon>
            </el-badge>
            <el-badge v-else class="item">
              <!-- <i class="iconfont icon-xiaoxi" /> -->
              <el-icon color="#c08c58" size="20" style="margin-top: 10px">
                <Bell />
              </el-icon>
            </el-badge>
            消息
            <div class="msgList">
              <div class="msgHead">
                <a
                  class="headItem"
                  :class="{ active: messageData.msgType === 0 }"
                  @click="handlerTabs(0)"
                >
                  待办<el-badge :value="messageData.toDoNum ? messageData.toDoNum : 0" class="item"></el-badge>
                </a>
                <a
                  class="headItem"
                  :class="{ active: messageData.msgType === 1 }"
                  @click="handlerTabs(1)"
                >
                  消息<el-badge :value="messageData.msgNum ? messageData.msgNum : 0" class="item"></el-badge>
                </a>
              </div>
              <div class="msgCon" v-show="messageData.msgType === 0">
                <div
                  class="item"
                  v-for="item in messageData.toDoList"
                  :key="item.scheduleConnectedId"
                  @click="goPage('/toDo')"
                >
                  <div class="icon">
                  </div>
                  <div class="info">
                    <!-- text21 -->
                    <div class="title">
                      您的标的<span>{{ item.scheduleName }}</span
                      >待{{ item.scheduleTypeName }}
                    </div>
                    <div class="subTitle">{{ item.scheduleTime }}</div>
                  </div>
                </div>
                <div class="msgFoot" @click="goPage('/toDo')"><el-icon class="mr5"><View /></el-icon>查看更多</div>
              </div>

              <div class="msgCon" v-show="messageData.msgType === 1">
                <div
                  class="item"
                  v-for="item in messageData.msgList"
                  :key="item.dmessageIds"
                  @click="goPage('/myMsg')"
                >
                  <div class="icon">
                  </div>
                  <div class="info">
                    <!-- text21 -->
                    <div class="title">{{ item.message }}</div>
                    <div class="subTitle">{{ item.createTime }}</div>
                  </div>
                </div>
                <div class="msgFoot" @click="goPage('/myMsg')"><el-icon class="mr5"><View /></el-icon>查看更多</div>
              </div>
            </div>
          </div>
          <div class="user iconRow" @click="routePush('/myPageHome', 'myhome')">
            <!-- <i class="iconfont icon-ren" /> -->
            <el-icon color="#c08c58" size="20">
              <Avatar />
            </el-icon>
            {{ user.username }}
          </div>
          <div class="loginOut iconRow" @click="handleLogout">
            <!-- <i class="iconfont icon-denglu" /> -->
            <el-icon class="exit"   color="#c08c58" size="20">
              <SwitchButton />
            </el-icon>
            退出
          </div>
        </div>
      </div>
    </div>
    <div class="header-title">
      <div class="header-titles">
        <div
          @click="toPath(item)"
          v-for="(item, index) in navs"
          :key="index"
          class="item shouzhi"
          :class="activeIndex === index ? 'item-on' : ''"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </header>
</template>

<script lang="ts">
import router from "@/router";
import {
  defineComponent,
  ref,
  watch,
  toRefs,
  reactive,
  onMounted,
  onUpdated,
  inject,
} from "vue";
import UserData from "@/store/user";
import { useRouter } from "vue-router";
import { loginOut } from "@/api/login";
import { getMsg, getBidingBidVoList } from "@/api/test";
import { ElMessage, ElMessageBox } from "element-plus";
import { ElNotification } from "element-plus";
export default defineComponent({
  name: "userNavHtml",
  components: {},
  setup(props) {
    const UserDataStore = UserData();
    const Router = useRouter();
    const activeIndex = ref(0);
    const data: any = reactive({
      tableData: [],
      acActive: 0,
      down: "", //竞价室倒计时
      router_path: "", //当前路由
      ws_url: "",
    });
    const emitter: any = inject("emitter"); // Inject `emitter`
    emitter.on("leavePage2", (value: any) => {
      // 监听事件
      console.log(value);
      data.down = value;
      // TODO do something
    });
    const routers = Router.options.routes.filter((item, index) => {
      return item?.meta?.isShowNav;
    });
    const navs = routers.map((item) => {
      return {
        title: item?.meta?.title,
        path: item?.path,
      };
    });

    const setActiveIndex = (index: any) => {
      activeIndex.value = index;
    };
    router.afterEach((to) => {
      routers.filter((item, index) => {
        if (to.path === item.path) {
          activeIndex.value = index;
        }
      });
    });
    //向竞价室发送事件
    const leavePage = () => {
      emitter.emit("leavePage", "leavePage");
    };
    //跳转登录注册
    const routePush = (res: number | string, name: any) => {
      leavePage();
      if (router.currentRoute.value.path == "/jingjiaing" && data.down != 0) {
        ElMessageBox.confirm(
          "您当前正在参与竞价中，离开可能无法及时浏览最新出价，是否确定离开~",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then((result) => {
          router.push({
            path: `${res}`,
            query: {
              name: name,
            },
          });
        });
        return;
      }
      router.push({
        path: `${res}`,
        query: {
          name: name,
        },
      });
    };
    const toPath = (item: any) => {
      leavePage();
      if (router.currentRoute.value.path == "/jingjiaing" && data.down != 0) {
        ElMessageBox.confirm(
          "您当前正在参与竞价中，离开可能无法及时浏览最新出价，是否确定离开~",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then((result) => {
          router.push(item.path);
        });
        return;
      }
      router.push(item.path);
    };

    const handleLogout = () => {
      loginOut({}).then((res: any) => {
        if (res.code === 200) {
          UserDataStore.SET_USER({});
          UserDataStore.SET_Login(false);
          router.push("/");
        }
      });
    };

    const goUserInfo = () => {
      router.push({
        path: "/info",
      });
    };
    // 监听是否登录事件
    const loginType = reactive({
      isLogin: UserDataStore.$state.isLogin,
      user: UserDataStore.$state.user,
    });
    watch(
      () => UserDataStore,
      (a) => {
        loginType.isLogin = a.$state.isLogin;
        loginType.user = a.$state.user;
        if (loginType.isLogin) {
          initSocket();
        }
      },
      { deep: true }
    );
    const messageData: any = reactive({
      msgList: [],
      toDoList: [],
      messageNum: 0,
      toDoNum: 0,
      msgType: 0,
      newTodoId: null,
    });
    const handlerTabs = (index: any) => {
      console.log(messageData.msgType);
      messageData.msgType = index;
    };
    const routclickss = (item: any) => {
      router.push({
        path: "/CompetitionView",
        query: {
          bidIds: item,
        },
      });
    };
    let newId: any = null;
    let getCount = 0;

    const initSocket = () => {
      let custId = "c-" + UserDataStore.$state.user.custId;
      if (process.env.VUE_APP_WSURL) {
        data.ws_url = process.env.VUE_APP_WSURL + custId + "";
      } else {
        // data.ws_url = "ws://45.119.63.165:8080/ws/websocket/"  + custId + "";
        data.ws_url = "ws://172.30.203.23:9205/dev-api/ws/websocket/"  + custId + "";

      }
      let ws = new WebSocket(data.ws_url);
      ws.onopen = function () {
        console.log("webSocket已打开");
        getListMsg();
      };
      ws.onmessage = (res: any) => {
        console.log(res, "webSocket推送消息");
        handleWebSocketMsg(res.data);
      };
      ws.onclose = (e) => {
        console.log("webSocket已断开", e);
        initSocket();
      };
    };
    const handleWebSocketMsg = (res: any) => {
      const data = JSON.parse(res);
      if (data.message == "update") {
        console.log("去更新数据");
        setTimeout(()=>{
          getListMsg();
        },1000)
        
      }
    };
    const getListMsg = () => {
      getMsg().then((res: any) => {
        if (res && res.data) {
          let data = res.data;
          messageData.msgNum = data.countMessage ? data.countMessage : "";
          messageData.toDoNum = data.countSchedule ? data.countSchedule : "";
          messageData.msgList =
            data.messageList.length > 0 ? data.messageList : [];
          messageData.toDoList =
            data.scheduleList.length > 0 ? data.scheduleList : [];
          if (data.scheduleList.length > 0) {
            newId = res.data.scheduleList[0].scheduleConnectedId;
          }

          if (getCount == 0 && messageData.toDoList.length > 0) {
            let msg = `您的标的【${messageData.toDoList[0].scheduleName}】待${messageData.toDoList[0].scheduleTypeName}`;
            sendMsg("您有新的待办事项待处理", msg);
          } else {
            if (
              data.scheduleList.length > 0 &&
              res.data.scheduleList[0].scheduleConnectedId != newId
            ) {
              let msg = `您的标的【${messageData.toDoList[0].scheduleName}】待${messageData.toDoList[0].scheduleTypeName}`;
              sendMsg("您有新的待办事项待处理", msg);
            }
          }
          getCount++;
        }
      });
    };
    const goPage = (url: any) => {
      router.push({
        path: url,
      });
    };
    //getListMsg()
    const sendMsg = (title: any, msg: any) => {
      ElNotification({
        title: title,
        message: msg,
        type: "warning",
        position: "bottom-right",
      });
    };

    //有正在竞价的标的跳转
    const getBidingBidVoListFN = () => {
      getBidingBidVoList().then((res) => {
        if (res.code == 200) {
          if (res.data.length) {
            // alert(router.currentRoute.value.path)
            // console.log(data.router_path)
            if (data.router_path == "/jingjiaing") {
              return;
            }
            for (let i = 0; i < res.data.length; i++) {
              console.log(res.data);
              if (res.data.length > 1) {
                ElMessageBox.confirm(`您已经报名的多个标的正在竞价中；`, {
                  cancelButtonText: "取消",
                  confirmButtonText: "快速参与",
                  type: "warning",
                  center: true,
                }).then(() => {
                  router.push({
                    path: "/biddingroom",
                  });
                });
                return;
              }
              ElMessageBox.confirm(
                `您已经报名的(${res.data[i].bidName})正在竞价中；`,
                {
                  cancelButtonText: "取消",
                  confirmButtonText: "快速参与",
                  type: "warning",
                  center: true,
                }
              ).then(() => {
                router.push({
                  path: "/jingjiaing",
                  query: {
                    id: res.data[i].bidIds,
                  },
                });
              });
            }
          }
        }
      });
    };

    onMounted(() => {
      if (loginType.isLogin) {
        initSocket();
        setTimeout(() => {
          data.router_path = router.currentRoute.value.path;
          console.log(data.router_path);
          getBidingBidVoListFN();
        }, 1000);
      }
    });
    // onUpdated(() => {
    //   if (loginType.isLogin) {
    //     initSocket();
    //   }
    // });

    return {
      handleLogout,
      goUserInfo,
      handlerTabs,
      toPath,
      routePush,
      routclickss,
      navs,
      UserDataStore,
      messageData,
      setActiveIndex,
      goPage,
      leavePage,
      getBidingBidVoListFN,
      ...toRefs(data),
      ...toRefs(loginType),
      activeIndex,
      initSocket,
    };
  },

  data() {
    return {
      queryInfo: {
        query: "",
      },
    };
  },
});
</script>

<style lang="scss" scoped>
.msgFoot {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color:#888888;
  background-color: #F7F8FA;
  padding-right: 20px;
}

.searchCon {
  width: 450px;
  height: 44px;
  border: 1px solid #ebeced;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  input {
    color: #333;
    padding-left: 15px;
    width: 330px;
  }

  .button {
    background-image: linear-gradient(90deg, #d4b08d, #b97f48);
    position: absolute;
    right: 0;
    top: -1px;
    border-radius: 0 5px 5px 0;
    height: 44px;
    width: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
}

.header {
  position: sticky;
  top: 0;
  background: #fff;
  min-width: 1400px;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 148px;
  z-index: 200;

  .warp {
    display: flex;
    justify-content: space-between;
    width: 1400px;
    height: 100px;
    align-items: center;

    .rightBar {
      .rightIcon {
        display: flex;
        align-items: center;

        .iconRow {
          display: flex;
          align-items: center;
          margin-left: 20px;
          cursor: pointer;
          transition: all 0.2s;
          height: 50px;

          .iconfont {
            color: #c08c58;
            font-size: 21px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}

.headItem {
  height: 49px;
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: center;
}

.headItem.active {
  border-bottom: 2px solid #c08c58;
  color: #C08C58;
  font-weight: bold;
}

.header-title {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #231f20;
  width: 100%;

  &s {
    height: 48px;
    width: 1200px;
    min-width: 1200px;
    display: flex;
    justify-content: space-between;

    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: normal;
      color: #ffffff;
      font-size: 18px;
    }

    .item:hover,
    .item-on {
      background: #c08c58;
    }
  }
}

.message .msgList {
  display: none;
}

.message:hover .msgList {
  display: block;
}

.message {
  position: relative;

  .msgList {
    position: absolute;
    width: 340px;
    // height: 326px;
    background-color: #fff;
    right: -30px;

    top: 42px;
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);

    .msgHead {
      border-bottom: 1px solid #e5e6eb;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .msgCon {
      .item {
        border-bottom: 1px solid #e5e6eb;
        display: flex;
        align-items: center;
        padding: 14px 17px;

        .icon {
          width: 6px;
          height: 6px;
          border-radius:6px;
          margin-right: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #C08C58;
          flex-shrink: 0;
        }

        .title {
          font-size: 14px;
        }

        .subTitle {
          color: #65686D;
          font-size: 14px;
        }
      }
    }
  }
}

.msgCon::after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  border-left: 14px solid transparent;
  border-right: 14px solid transparent;
  border-bottom: 20px solid #fff;
  position: absolute;
  right: 30px;
  top: -10px;
}

.msgList::after {
  content: "";
  height: 1px;
  width: 14px;
  background-color: #e5e6eb;
  position: absolute;
  transform: rotate(50deg);
  top: -6px;
  right: 29px;
}

.msgList::before {
  content: "";
  height: 1px;
  width: 14px;
  background-color: #e5e6eb;
  position: absolute;
  top: -6px;
  transform: rotate(-50deg);
  right: 39px;
}

@font-face {
  font-family: "iconfont";
  src: url("data:application/x-font-woff2;charset=utf-8;base64,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")
    format("woff2");
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-logo:before {
  content: "\e600";
}

.icon-zhuce:before {
  content: "\e71c";
}

.icon-ren:before {
  content: "\e604";
}

.icon-weidenglu:before {
  content: "\e6a3";
}

.icon-xiaoxi:before {
  content: "\e60f";
}

.icon-denglu:before {
  content: "\e610";
}

.exit.el-icon svg {
  height: 2em;
  width: 2em;
}
</style>
